import { IShopifySellingPlanAllocation } from '../_models/shopify-subscription.model';

export function getSellingPlanAllocationsFromVariantNode(variantNode: any): Array<IShopifySellingPlanAllocation> {
  // Get Subcription Plan
  return variantNode.sellingPlanAllocations?.edges?.map((allocationEdge: any) => {
    const allocationNode = allocationEdge?.node;
    const sellingPlan = allocationNode?.sellingPlan;
    const priceAdjustments = allocationNode?.priceAdjustments;

    const sellingPlanAllocation: IShopifySellingPlanAllocation = {
      sellingPlanId: sellingPlan.id,
      variantPriceAdjustments: priceAdjustments?.map((priceAdjustment: any) => {
        return {
          compareAtPrice: priceAdjustment.compareAtPrice?.amount,
          perDeliveryPrice: priceAdjustment.perDeliveryPrice?.amount,
          price: +priceAdjustment.price?.amount
        }
      }),
      sellingPlan: {
        id: sellingPlan.id,
        name: sellingPlan.name,
        priceAdjustments: []
      }
    };

    return sellingPlanAllocation;
  });

}
